import { render, staticRenderFns } from "./ChoiceEditSidebar.vue?vue&type=template&id=7adfc335&scoped=true&"
import script from "./ChoiceEditSidebar.vue?vue&type=script&lang=ts&"
export * from "./ChoiceEditSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceEditSidebar.vue?vue&type=style&index=0&id=7adfc335&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfc335",
  null
  
)

export default component.exports